import { render, staticRenderFns } from "./indexModel.vue?vue&type=template&id=77930c7c&scoped=true&"
import script from "./indexModel.vue?vue&type=script&lang=js&"
export * from "./indexModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77930c7c",
  null
  
)

export default component.exports